import React, { useState } from "react";
import "./Medication.scss";
import { HomeOutlined, DownloadOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useMedicationSingleViewQuery } from "../../utils/apiSlice";
import { useEffectiveUserData } from "../../hooks/useEffectiveUserData";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useLocation } from "react-router-dom";

const MedicationDetail = () => {
    const [activeChips, setActiveChips] = useState<string[]>(["Cough"]);

    const location = useLocation();
    const detail = location.state;
    console.log(detail)

    const navigate = useNavigate();
    const userData = useEffectiveUserData();
    const patientId = userData?.patientId || 36;
    const [isPrinting, setIsPrinting] = useState(false);

    const [yourValue,setYourValue] = useState('Hydration is critical. Avoid heavy sodium. Rise slowly to prevent orthostatic')

    const { data, isLoading } = useMedicationSingleViewQuery(patientId);

    const chips = ["Cough", "Dizziness", "Headache", "Fatigue", "Nausea"];

    const toggleChip = (chip: string) => {
        setActiveChips((prev) =>
            prev.includes(chip)
                ? prev.filter((c) => c !== chip)
                : [...prev, chip]
        );
    };

    const firstMed = data?.[0];

   const handleDownloadPDF = async () => {
  const element = document.querySelector(".premium-container") as HTMLElement;
  if (!element) return;

  setIsPrinting(true);

  // 1. Clone
  const tempContainer = element.cloneNode(true) as HTMLElement;

  // 2. Remove unwanted elements
  const elementsToRemove = tempContainer.querySelectorAll(
    ".pdf-download-btn, .btn, .hide-in-pdf"
  );
  elementsToRemove.forEach((el) => el.remove());

  // 🔥🔥🔥 3. ADD YOUR CODE HERE (VERY IMPORTANT)
  
  // ✅ Convert textarea → div
  const textareas = tempContainer.querySelectorAll("textarea");

  textareas.forEach((textarea: any) => {
    const div = document.createElement("div");

    div.innerText = textarea.value || textarea.innerText || "";
    div.style.whiteSpace = "pre-wrap";
    div.style.wordBreak = "break-word";
    div.style.padding = "10px";
    div.style.minHeight = textarea.scrollHeight + "px";
    div.style.border = "1px solid #ddd";
    div.style.borderRadius = "6px";
    div.style.fontSize = "14px";
    div.style.fontFamily = "inherit";
  
    div.style.background = "#f5f7fa"; 

    textarea.parentNode.replaceChild(div, textarea);
  });

  // ✅ Convert input → div
  const inputs = tempContainer.querySelectorAll("input");

  inputs.forEach((input: any) => {
    const div = document.createElement("div");

    div.innerText = input.value || "";
    div.style.padding = "8px 10px";
    div.style.border = "1px solid #ddd";
    div.style.borderRadius = "6px";
    div.style.fontSize = "14px";
    

    input.parentNode.replaceChild(div, input);
  });

  // 🔥 4. Apply styles
  Object.assign(tempContainer.style, {
    width: "1200px",
    position: "absolute",
    top: "-9999px",
    left: "-9999px",
    backgroundColor: "#ffffff",
  });

  document.body.appendChild(tempContainer);

  try {
    // 🔥 5. NOW call html2canvas
    const canvas = await html2canvas(tempContainer, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      windowWidth: 1200,
      scrollY: -window.scrollY,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`${firstMed?.medicineName || "medication"}-report.pdf`);
  } catch (error) {
    console.error("PDF Generation failed:", error);
  } finally {
    document.body.removeChild(tempContainer);
    setIsPrinting(false);
  }
};

    return (
        <div className="content-wrapper">
            <div className="container-full table-padding">
                <div className="page-header">
                    <div className="breadcrumb">
                        <h4 className="page-title">Medication</h4>
                        <span className="customize-breadcrumb">
                            <span className="home-icon" onClick={() => navigate("/dashboard")}><HomeOutlined /> </span>
                            <span className="separator "> - </span>
                            <span className="current">Medication Detail</span>
                        </span>
                    </div>
                </div>
                <div className={`premium-container ${isPrinting ? "printing-mode" : ""}`}>
                    <div className="premium-header d-flex justify-content-between align-items-center">
                        <div>
                            <h3 className="mb-1 fw-medium">Medication Detail</h3>
                            <p className="mb-0 opacity-75">
                                Patient Health Log • {detail?.medicationName || "-"}
                            </p>
                        </div>
                        {!isPrinting && (
                            <button className="btn pdf-download-btn" onClick={handleDownloadPDF}>
                                <DownloadOutlined className="me-2" />
                                Download PDF
                            </button>
                        )}
                    </div>

                    <div className="info-grid">
                        <div className="info-item">
                            <label>Medicine</label>
                            <span>{detail?.medicationName || "-"}</span>
                        </div>

                        <div className="info-item">
                            <label>Type</label>
                            <span>{detail?.type || "-"}</span>
                        </div>

                        <div className="info-item">
                            <label>Daily Dosage</label>
                            <span>{detail?.dosage || "-"}</span>
                        </div>

                        <div className="info-item">
                            <label>Frequency</label>
                            <span>{detail?.frequency || "-"}</span>
                        </div>

                        <div className="info-item">
                            <label>Routine</label>
                            <span>{detail?.routine || "-"}</span>
                        </div>

                        <div className="info-item">
                            <label>Cause</label>
                            <span>{detail?.cause || "-"}</span>
                        </div>

                        <div className="info-item">
                            <label>Start Date</label>
                            <span>{detail?.dateDetail || "-"}</span>
                        </div>

                        <div className="info-item">
                            <label>Duration</label>
                            <span>{detail?.duration || "-"}</span>
                        </div>

                        <div className="info-item">
                            <label>Timings</label>
                            <span>
                                {detail?.times?.length
                                    ? detail.times.join(", ")
                                    : "-"}
                            </span>
                        </div>

                        <div className="info-item">
                            <label>Therapy Status</label>
                            <span className={detail?.status === "Active" ? "text-success" : "text-danger"}>
                                <i className="fas fa-circle me-1 small"></i>
                                {detail?.status || "Inactive"}
                            </span>
                        </div>
                    </div>


                    <div className="p-5">
                        <div className="row g-5 p-5">
                            <div className="col-lg-7 ">
                                <div className="mb-5">
                                    <label className="field-label">
                                        <i className="fas fa-info-circle"></i> Reason of Medication
                                    </label>
                                    <input
                                        type="text"
                                        className="tara-input"
                                        defaultValue="Primary Hypertension Management"
                                    />
                                </div>

                                <div className="mb-5">
                                    <label className="field-label">
                                        <i className="fas fa-sparkles"></i> AI Generated Side Effects
                                    </label>

                                    <div className="chip-container">
                                        {chips.map((chip) => (
                                            <div
                                                key={chip}
                                                className={`tara-chip ${activeChips.includes(chip) ? "active" : ""
                                                    }`}
                                                onClick={() => toggleChip(chip)}
                                            >
                                                {chip}
                                            </div>
                                        ))}
                                    </div>

                                    <textarea
                                        className="tara-input"
                                        rows={2}
                                        placeholder="Describe clinical symptoms..."
                                    />
                                </div>

                                <div>
                                    <label className="field-label">
                                        <i className="fas fa-notes-medical"></i> Self-Observations
                                    </label>
                                    <textarea
                                        className="tara-input"
                                        rows={6}
                                        defaultValue="Patient reports stabilized BP at 120/75. Noting a mild, dry cough—no other ACE-inhibitor typical reactions observed."
                                    />
                                </div>
                            </div>

                            <div className="col-lg-5">
                                <div className="mb-4">
                                    <label className="field-label">
                                        <i className="fas fa-shield-virus"></i> Drug Interaction Alert
                                    </label>
                                    <div className="tara-alert">
                                        <i className="fas fa-exclamation-circle"></i>
                                        <div>
                                            <strong className="d-block mb-1">
                                                Potassium Risk
                                            </strong>
                                            <span className="small text-muted">
                                                High interaction risk with Potassium supplements. Monitor
                                                electrolyte levels.
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <label className="field-label">
                                        <i className="fas fa-hand-holding-heart"></i>{" "}
                                        Precautionary Alerts
                                    </label>
                                    <div className="p-5">
                                    <textarea
                                        className="tara-input   p-5 pdf-textarea" 
                                        
                                         onChange={(e) => setYourValue(e.target.value)}
                                      rows={10}
                                         value={yourValue}  
                                    />
                                    </div>
                                </div>

                                <div>
                                    <label className="field-label">
                                        <i className="fas fa-chart-area"></i> Vital Trend (BP)
                                    </label>
                                    <div className="vital-box">
                                        <i className="fas fa-wave-square fa-2x mb-3 text-light"></i>
                                        <p className="small text-muted mb-0">
                                            BP sitting at 120/75 mmHg
                                            <br />
                                            Trend: Stabilizing
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {!isPrinting && (
                            <div className="mt-5 pt-5 border-top d-flex justify-content-end align-items-center">
                                <button className="btn btn-primary me-3">Save</button>
                                <button className="btn btn-danger">RE</button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MedicationDetail;
